// src/utils/normalizeUnit.js
// Maps upstream fusion_units items into a canonical shape used by ops UI.

function slugify(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

const UNIQUENESS_MAP = {
  mod: "mod",
  model: "mod",
  alt: "alt",
  adp: "adp",
  bmr: "bmr",
};
const UNIQUENESS_ORDER = ["mod", "alt", "adp", "bmr"];

function normalizeUniqueness(value) {
  const tags = String(value || "")
    .split(",")
    .map((token) => slugify(token))
    .filter(Boolean)
    .map((token) => UNIQUENESS_MAP[token] || token);

  return Array.from(new Set(tags))
    .sort((left, right) => {
      const leftIndex = UNIQUENESS_ORDER.indexOf(left);
      const rightIndex = UNIQUENESS_ORDER.indexOf(right);
      const normalizedLeft = leftIndex === -1 ? Number.MAX_SAFE_INTEGER : leftIndex;
      const normalizedRight = rightIndex === -1 ? Number.MAX_SAFE_INTEGER : rightIndex;
      if (normalizedLeft !== normalizedRight) return normalizedLeft - normalizedRight;
      return left.localeCompare(right);
    })
    .join(",");
}

export function normalizeUnit(item = {}) {
  return {
    project_id: item.project_id ?? item.projectId ?? "",
    building_id: item.building_id ?? item.buildingId ?? "",
    unit_number: item.unit_number ?? item.unitNumber ?? "",
    sequence: item.sequence ?? item.phase ?? item.Sequence ?? "",
    uniqueness: normalizeUniqueness(
      item.uniqueness ?? item.unique ?? item.uniqueness_tag ?? item.Uniqueness ?? ""
    ),
    plan_type: item.plan_type ?? item.plan ?? "",
    plan_sf: num(item.plan_sf ?? item.sqft ?? item.planSqft),
    address: item.address ?? "",
    bedrooms: num(item.bedrooms),
    bathrooms: num(item.bathrooms),
    region: item.region ?? item.Region ?? "",
    state: item.state ?? item.State ?? "",
    floorplan_key: item.floorplan_key ?? item.pdf_key ?? "",
    // add through-only fields as needed
  };
}

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}
